import { render, staticRenderFns } from "./TypeTab.vue?vue&type=template&id=eea301d4"
import script from "./TypeTab.vue?vue&type=script&lang=js"
export * from "./TypeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports